import { useCallback, useState } from 'react';
import { runToast } from '@restore/tools';

const deniedFiles = {
  types: ['application/x-msdownload'],
  extensions: ['.exe', '.dll', '.msi', '.cmd', '.bat', '.sh', '.vbs'],
};

export const checkDeniedFiles = (files: File[]) => {
  const denied = files.some(file => {
    const { type, name } = file;
    const extension = name.split('.').pop() ?? '';
    console.log(type, name, extension);

    return (
      deniedFiles.types.includes(type) ||
      deniedFiles.extensions.includes('.' + extension)
    );
  });

  return denied;
};

export const useAttachFiles = (onChange: (files: File[]) => void) => {
  const [uploadingFiles, setUploadingFiles] = useState<File[]>([]);

  const removeFile = useCallback(
    (file: File) => {
      setUploadingFiles(prev => {
        const updated = prev.filter(f => f !== file);
        onChange(updated);
        return updated;
      });
    },
    [onChange]
  );

  const resetFiles = useCallback(() => {
    setUploadingFiles([]);
  }, []);

  const onAttachFiles = useCallback(
    (files: File | File[]) => {
      let fls = files as File[];

      if (!Array.isArray(files)) {
        fls = [files];
      }
      const isDenied = checkDeniedFiles(fls);

      if (isDenied) {
        runToast('error', 'You can\'t upload this type of file');
        return;
      }
      setUploadingFiles(fls);
      onChange(fls);

      return fls;
    },
    [onChange]
  );

  return { onAttachFiles, uploadingFiles, removeFile, resetFiles };
};
